import script from "./CareerBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerBlock.vue?vue&type=script&setup=true&lang=js"

import "./CareerBlock.vue?vue&type=style&index=0&id=790be3c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-790be3c7"]])

export default __exports__